import { AuthService } from 'app/_services/auth.service';
import { ActivitiesService } from 'app/_services/activities.service';
import * as angular from 'angular';
import { mgoAngularWizard, StorageBookingWizardContext } from '../custom';

class StorageBookingWizardCtrl implements ng.IController {
    public wizardName: string;
    public wizard: mgoAngularWizard.Wizard<StorageBookingWizardContext>;

    constructor(
        private WizardHandler: mgoAngularWizard.WizardHandler<StorageBookingWizardContext>,
        private authService: AuthService,
        private activitiesService: ActivitiesService
    ) {
        this.wizardName = 'Storage FCFS booking';
    }

    $onInit(): void {}

    $doCheck(): void {
        if (this.wizard) {
            return;
        }

        let wizard: mgoAngularWizard.Wizard<StorageBookingWizardContext> =
            this.WizardHandler.wizard(this.wizardName);

        if (wizard) {
            this.wizard = wizard;
            this.wizard.context.successfulBooking = false;
        }
    }

    public startOver(): void {
        this.wizard.reset();
        this.wizard.context.successfulBooking = false;
    }
}

angular.module('app').component('pkpStorageBookingWizard', {
    controller: StorageBookingWizardCtrl,
    template:
        require('app/storage-booking-wizard/storage-booking-wizard.component.html'),
    bindings: {}
});
